function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "26 21.55 21.84 17.55 21.84 19.79 18.01 19.79 18.01 23.39 21.84 23.39 21.84 25.55 26 21.55",
    style: {
      fill: "#9868b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.85,20l-.26.16c-.53.36-2.46.19-4.05-2.66s-.83-4.67-.27-4.89L11.34,12a1.12,1.12,0,0,0,.45-1.4L9.72,6.86A1.11,1.11,0,0,0,8.3,6.42c0,.07-1.14.61-1.14.7C5.58,8,4.78,9.85,4.87,12.45a15.25,15.25,0,0,0,2.2,6.85,17.07,17.07,0,0,0,4.77,5.41,8.87,8.87,0,0,0,1.95,1Z",
    style: {
      fill: "#7e7e7e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialOther);
export default __webpack_public_path__ + "static/media/dial-other.9b822cc6.svg";
export { ForwardRef as ReactComponent };